import { PORT_IN_ROUTE } from "@api-routes";
import { useFetch } from "@common/hook/useFetch";
import { getStateToPayload } from "../mappers/deletePortInMapper";

export const useCancelPortIn = (getPortIn: () => void, portInId?: number) => {
    const [cancelPortInState, { deleteCall }] = useFetch();

    const handleCancelPortIn = () => {
        if (portInId) {
            deleteCall<boolean>(PORT_IN_ROUTE, { body: getStateToPayload(portInId) }).then((cancelPortInResponse) => {
                if (cancelPortInResponse) {
                    getPortIn();
                }
            });
        }
    };

    return { cancelPortInState, handleCancelPortIn };
};
